<template>
  <div class="disposables_index">
    <div class="search-line">
        <div class="left">
          <!-- 耗材 -->
          <el-input v-model="queryParams.name" class="search-input" clearable :placeholder="`耗材`"></el-input>
          <!-- 查询 -->
          <el-button type="primary" icon="el-icon-search" size="mini" @click="getSearch">查询</el-button>
          <!-- 导入 -->
          <el-button type="primary" icon="el-icon-upload2" size="mini" @click="importList()">导入</el-button>
          <!-- 新建 -->
          <el-button type="primary" icon="el-icon-plus" size="mini" @click.prevent="createDisposables">新建</el-button>
        </div>
        <table-header-editor :headers="tableHeaders"  class="header-editor" />
    </div>
    <el-tabs v-model="queryParams.type"  @tab-click="getList()">
      <el-tab-pane
        v-for="(item) in sorts"
        :key="item.value"
        :label="item.name"
        :name="item.value + ''"
      >
      </el-tab-pane>
    </el-tabs>
    <div class="disposables_center">
      <div class="list-content">
        <el-table
          :data="list"
          stripe 
          v-loading="loading"
          :header-cell-class-name="'table-header-cell'"
          @sort-change="sortChange"
          border
        >
          <el-table-column
            v-for="(item) in tableHeaders"
            :key="item.id"
            :type="item.type"
            :label="item.label"
            :prop="item.prop"
            :sortable="!!item.sortKey ? 'custom': false"
            :sort-by="item.sortKey"
            :width="item.width">
              <template slot-scope="scope">
                <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
                
                <el-tooltip :key="index" v-for="(item,index) in scope.row.image" v-else-if="item.prop === 'imgshow'" effect="dark" :content="`点击查看大图`" placement="top-start">
                  <el-image 
                    style="height: 30px;margin-right:5px;"
                    :src="item.url" 
                    :preview-src-list="srcListTwo" >
                  </el-image>
                </el-tooltip>
                
                <el-button v-else-if="item.prop === 'setUp'" effect="dark" size="mini" type="primary" @click="changeDisposable(scope.row.id)">转为器械</el-button>
                
                <span v-else>{{scope.row[item.prop]}}</span>
                <!-- 编辑 -->
                <el-tooltip v-if="item.handle" effect="dark" :content="`编辑`" placement="top-start">
                  <el-button class="p0 fontsize20" type="text" @click.prevent="editDisposables(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
                </el-tooltip>
                <!-- 删除 -->
                <el-tooltip v-if="item.handle" effect="dark" :content="`删除`" placement="top-start">
                  <el-button class="p0 fontsize20" type="text" @click.prevent="deleteDisposables(scope.row.id)"><i class="el-icon-delete"></i></el-button>
                </el-tooltip>
              </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination :queryParams="queryParams" :getList="getList" />
    </div>
    <!-- 耗材管理 -->
    <ImportFile :link="'/template/basic/disposable/'+`耗材管理`+'.xlsx'" ref="importFile" @complete="getImport" />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'
import TableHeaderEditor from '@/components/common/TableHeaderEditor.vue'
import ImportFile from '@/components/common/ImportFile.vue'
import { disposablesList, disposablesDelete,disposablesChange,disposableImport } from '@/api.js' 
import { pageSize } from '@/utils/Config.js'
export default {
    name:'disposablesIndex',
    components: {
      Pagination,
      TableHeaderEditor,
      ImportFile
    },
    data() {
        return {
            // 查询参数
            queryParams: {
              pageIndex: 1,
              pageSize,
              _total: 0,
              name: '',
            },
            tableHeaders: [],
            //器械列表
            list:[],
            typeOptions:[],
            sorts:[],
            loading: false,
            total: 0,
            url: '',
            srcList: [],
            srcListTwo: [],
        }
    },
    created() {
      this.getList();
      this.searchTypeOption();
    },
    methods: {
      /** 查询器械列表 */
      getSearch(){
        this.queryParams.pageIndex = 1;
        this.getList();
      },
      importList() {
        // 开始导入
        this.$refs.importFile.show()
      },
      getImport(file) {
        // 接收导入文件信息
        const info = {
          file_id: file.fileId
        }
        this.$request('post', disposableImport, info)
        .then((res) => {
          if (res) {
            // 导入成功
            this.$message.success(`导入成功`)
            this.getList()
          }
        })
      },
      getList() {
        // 获取列表数据
        const url = disposablesList
        const {
          pageIndex,
          pageSize,
          name,
          type,
          departId,
          orderBy,
          order
        } = this.queryParams
        const queryParams = {
          page: pageIndex,
          per_page: pageSize,
          name,
          type,
          order_column: orderBy,
          order,
          department_id: departId
        }
        this.$request('get', url, queryParams)
        .then((res) => {
          if (res) {
            const prev = [
              {
                width: 60,
                label: '#',
                prop: '',
                type: 'index',
                checked: true
              }
            ]
            const last = [
              {
                width: 'auto',
                // 图片
                label: `图片`,
                prop: 'imgshow',
                checked: true,
              },
              {
                // 设置
                width: 'auto',
                label: `设置`,
                prop: 'setUp',
                checked: true,
              },
              {
                // 操作
                width: 'auto',
                label: `操作`,
                prop: '',
                checked: true,
                handle: true
              }
            ]

            this.tableHeaders = this.tableHeaders.length > 0 ? this.tableHeaders : this.$utils.generateColumns(res.columns, prev, last)
            // console.log(this.tableHeaders);
            this.list = res.data
            for (let i = 0; i < res.data.length; i++) {
              this.srcList = res.data[i].image;
              for (let j = 0; j < this.srcList.length; j++) {
                this.srcListTwo.push(this.srcList[j].url)
              }
            }
            this.queryParams._total = res.total
          }
        })
        this.loading = false;
      },
      sortChange(item) {
        // 排序方法
        const { column, order } = item
        const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
        const orderBy = order ? column.sortBy : undefined

        this.queryParams.order = orderString
        this.queryParams.orderBy = orderBy
        this.getList()
      },
      // 新建耗材
      createDisposables(){
        const url = `${window.location.origin}/basic/disposables/edit/0`

        window.open(url, '_blank')
      },
      //编辑耗材
      editDisposables(row) {
        const url = `${window.location.origin}/basic/disposables/edit/${row.id || 0}`

        window.open(url, '_blank')
      },
      //查询耗材类型
      searchTypeOption(){
        return this.$utils.getDict(306).then((typeOptions) => {
          if(typeOptions){
            this.sorts = typeOptions[306];
            this.sorts.unshift({
              value: '0',
              // 全部耗材
              name: `全部耗材`
            })
            this.queryParams.type = this.sorts[0].value
          }
        })
      },
      //耗材删除
      deleteDisposables(id){
        // 确认删除吗？
        this.$confirm(`确认删除吗?`,{
          type: 'warning',
          // 确定
          confirmButtonText: `确定`,
          // 取消
          cancelButtonText: `取消`,
        })
        .then(() => {
          const url = disposablesDelete.replace('{id}', id)
          this.$request('post', url, {id})
          .then((res) => {
            if (res) {
              // 删除成功
              this.$message.success(`删除成功`)
              this.getList()
            }
          })
        })
        .catch(() => {
          console.log(`取消`)
        })
      },
      //耗材转为器械
      changeDisposable(id){
        // 确认转为器械吗？
        this.$confirm(`确认转为器械吗？`,{
          type: 'warning',
          // 确定
          confirmButtonText: `确定`,
          // 取消
          cancelButtonText: `取消`,
        })
        .then(() => {
          const url = disposablesChange.replace('{id}', id)
          this.$request('post', url, {id})
          .then((res) => {
            if(res){
              // 转为器械成功
              this.$message.success(`转为器械成功`)
              this.getList();
            }
          })
        })
      },
    }
}
</script>

<style lang="scss" scoped>
.disposables_index{
  .disposables_center{
    background: white;
    padding: 10px;
    border-radius: 10px;
  }
  .imageSize{
    font-size: 22px;
  }
  .header-editor {
    position: relative;
    right: 10px;
    z-index: 5;
    top:35px;
  }
}
</style>